import { Grid, Link, Paper, Typography } from "@mui/material";
import emailBasedOnEnv, {
  Email,
  generateEmailQuery,
} from "../../helper/generateEmail";
import { useContext } from "react";
import { UserDetailsContext } from "../HardwareDetails/HardwareDetails";

export default function Support({ isGermanyUser }: { isGermanyUser: boolean }) {
  const userDetails = useContext(UserDetailsContext);
  const emailAddress = isGermanyUser
    ? "de-gits-support@thoughtworks.com"
    : "gits-support@thoughtworks.com";
  const emailTemplate: Email = {
    to: emailAddress,
    subject: "Query on Hardware Asset",
    body:
      `\n\n\n\nRegards\n${userDetails.name}` +
      "\n----\nPlease do not remove text below, used for tracking purpose\n" +
      "source: myTW\n" +
      "Type: myTW_Workspace_Support_Request",
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant={"h3"} color={"primary.main"}>
          Additional questions?
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, marginBottom: "16px" }}>
          Send a mail to{" "}
          <Link
            color="secondary.main"
            href={generateEmailQuery(emailTemplate)}
            target="_blank"
            rel="noreferrer"
          >
            {emailAddress}
          </Link>
        </Paper>
      </Grid>
    </Grid>
  );
}
